import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b48ac8e")

_pushScopeId("data-v-9b48ac8e")
const _hoisted_1 = { class: "container chat-quotes-wrapper" }
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = { class: "chat-filter" }
const _hoisted_4 = { class: "filter-group-name" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, " ", -1)
const _hoisted_6 = { class: "filter-block" }
const _hoisted_7 = { class: "filter-block" }
const _hoisted_8 = { class: "filter-block" }
const _hoisted_9 = { class: "filter-block" }
const _hoisted_10 = { class: "filter-block" }
const _hoisted_11 = { class: "row flex-nowrap" }
const _hoisted_12 = { class: "col-7" }
const _hoisted_13 = { class: "chat-list-container" }
const _hoisted_14 = { class: "table-container desktop-grid" }
const _hoisted_15 = { class: "table" }
const _hoisted_16 = /*#__PURE__*/_createVNode("th", { scope: "col" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("th", { scope: "col" }, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "chat-date" }
const _hoisted_20 = { class: "chat-notification" }
const _hoisted_21 = {
  key: 0,
  class: "badge"
}
const _hoisted_22 = { class: "col-5 main-chat-block" }
const _hoisted_23 = {
  class: "d-flex flex-column",
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_24 = {
  key: 0,
  class: "order-quote-container"
}
const _hoisted_25 = { class: "quote-number-title" }
const _hoisted_26 = { class: "order-quote-info d-flex" }
const _hoisted_27 = { class: "quote-title" }
const _hoisted_28 = { class: "quote-value" }
const _hoisted_29 = { class: "quote-title" }
const _hoisted_30 = { class: "quote-value" }
const _hoisted_31 = { class: "quote-title" }
const _hoisted_32 = { class: "quote-value" }
const _hoisted_33 = { class: "quote-title" }
const _hoisted_34 = { class: "quote-value" }
const _hoisted_35 = { class: "quote-title" }
const _hoisted_36 = { class: "quote-value" }
const _hoisted_37 = {
  key: 1,
  style: {"padding":"20px 5px","font-size":"20px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ProductChat = _resolveComponent("ProductChat")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pageTitle.indexChatAndQuotes')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.keyword = $event)),
          class: "bookit-input w-100",
          type: "text",
          placeholder: _ctx.$t('chatFilter.searchByAgencyAndProviderName')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('chatFilter.provider')), 1),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filter.providerId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.providerId = $event)),
          searchable: true,
          "track-by": "name",
          options: _ctx.providers,
          valueProp: "id",
          label: "name"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('chatFilter.agency')), 1),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filter.indexAgencyId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.indexAgencyId = $event)),
          searchable: true,
          "track-by": "name",
          options: _ctx.indexAgencies,
          valueProp: "id",
          label: "name"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('chatFilter.agent-name')), 1),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filter.indexUserId,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.indexUserId = $event)),
          searchable: true,
          "track-by": "name",
          options: _ctx.indexUsers,
          valueProp: "id",
          label: "name"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('chatFilter.type')), 1),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filter.chatType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.chatType = $event)),
          searchable: true,
          valueProp: "id",
          label: "name",
          options: _ctx.chatTypes,
          "close-on-select": true
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("span", null, _toDisplayString(_ctx.$t('chatFilter.product')), 1),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filter.productId,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.productId = $event)),
          searchable: true,
          "track-by": "name",
          options: _ctx.products,
          valueProp: "id",
          label: "name"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("table", _hoisted_15, [
              _createVNode("thead", null, [
                _createVNode("tr", null, [
                  _createVNode("th", {
                    scope: "col",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortBy('Type')))
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('chat.type')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Type')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("th", {
                    scope: "col",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy('AgencyName')))
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('chat.agencyName')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('AgencyName')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("th", {
                    scope: "col",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBy('AgentName')))
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('chat.agentName')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('AgentName')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("th", {
                    scope: "col",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortBy('ProductName')))
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('chat.productName')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProductName')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("th", {
                    scope: "col",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortBy('ProviderName')))
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('chat.providerName')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderName')]
                      }, null, 2)
                    ])
                  ]),
                  _hoisted_16,
                  _hoisted_17
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredChats, (chat, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: index,
                    class: { active: _ctx.selectedChatIndex == index },
                    onClick: ($event: any) => (_ctx.chooseChat(chat, index))
                  }, [
                    _createVNode("td", null, _toDisplayString(chat.orderQuote ? _ctx.$t('chat.chatType.quote') : _ctx.$t('chat.chatType.chat')), 1),
                    _createVNode("td", null, _toDisplayString(chat.agencyName), 1),
                    _createVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: {
                                                    name: 'agent-details',
                                                    params: { id: chat.indexUserId }
                                                },
                        target: "_blank"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(chat.indexUserName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: {
                                                    name: 'product',
                                                    params: { id: chat.productId }
                                                },
                        target: "_blank"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(chat.productName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("td", null, _toDisplayString(chat.providerName), 1),
                    _createVNode("td", null, [
                      (chat.groupName)
                        ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(chat.groupName), 1))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatChatDate(chat.lastMessageDate)), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("i", {
                          class: [{ 'has-unreaded': chat.hasUnreadedMessages }, "icon-notifications-chat icon-f icon-message fs-24"]
                        }, null, 2),
                        (chat.hasUnreadedMessages)
                          ? (_openBlock(), _createBlock("span", _hoisted_21, "!"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 10, ["onClick"]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          (_ctx.selectedChat && _ctx.selectedChat.orderQuote)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('chat.quote.title')) + " #" + _toDisplayString(_ctx.selectedChat.orderQuote.id), 1),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('chat.quote.groupName')), 1),
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.selectedChat.orderQuote.name), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('chat.quote.date')), 1),
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.moment(_ctx.selectedChat.orderQuote.date).format('DD.MM.YYYY')), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('chat.quote.requested-time')), 1),
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('order-quote.requested-time.' + _ctx.getRequestedTime(_ctx.selectedChat.orderQuote.requestedTime))), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('chat.quote.participants')), 1),
                    _createVNode("div", _hoisted_34, _toDisplayString(_ctx.selectedChat.orderQuote.totalGuests), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('chat.quote.budgetPerPerson')), 1),
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.selectedChat.orderQuote.amount) + " " + _toDisplayString(_ctx.getCurrencySymbol(_ctx.selectedChat.orderQuote.currencyId)), 1)
                  ])
                ]),
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedChat.orderQuote.comments = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.selectedChat.orderQuote.comments]
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.selectedChat)
            ? (_openBlock(), _createBlock("div", _hoisted_37, _toDisplayString(_ctx.$t("chat.no-selected-chat")), 1))
            : _createCommentVNode("", true),
          (_ctx.selectedChat)
            ? (_openBlock(), _createBlock(_component_ProductChat, {
                key: 2,
                "product-id": _ctx.selectedChat.productId,
                "order-quote-id": _ctx.selectedOrderQuoteId,
                indexUserId: _ctx.selectedIndexUserId,
                "provider-id": _ctx.selectedChat.providerId
              }, null, 8, ["product-id", "order-quote-id", "indexUserId", "provider-id"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})